<template>
  <div class="manage-news">
    <router-view></router-view>
  </div>
</template>

<script>
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import AppConstants from "@/appConstants";
import imageLibStoreModule from "./imageLibStoreModule";

export default {
  setup() {
    // Register module
    if (!store.hasModule(AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME)) {
      store.registerModule(
        AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME,
        imageLibStoreModule
      );
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME))
        store.unregisterModule(AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME);
    });
  },
};
</script>

<style>
</style>